// Import language support for prism-react-editor
import "prism-react-editor/prism/languages/javascript";
import "prism-react-editor/prism/languages/jsx";
import "prism-react-editor/prism/languages/markup";
import { Box } from "@chakra-ui/react";
import { Editor } from "prism-react-editor";

import { useReflagCodeTheme } from "@/common/components/CodeEditor/useReflagCodeTheme";

import "prism-react-editor/layout.css";

export type SupportedHighlightLanguage =
  | "javascript"
  | "http"
  | "markdown"
  | "jsx"
  | "html"
  | "vue"
  | "json"
  | "json5";

// Map language names to prism-react-editor language identifiers
const languageMap: Record<SupportedHighlightLanguage, string> = {
  javascript: "javascript",
  http: "http",
  markdown: "markdown",
  jsx: "jsx",
  html: "markup", // prism uses 'markup' for HTML
  vue: "markup", // Vue SFC highlighting via markup + embedded JS
  json: "json",
  json5: "json", // prism doesn't have json5, use json
};

export default function CodeBlock({
  children,
  language = "javascript",
  showLineNumbers = true,
}: {
  children: string;
  language?: SupportedHighlightLanguage;
  showLineNumbers?: boolean;
}) {
  const theme = useReflagCodeTheme(false, true);
  const prismLanguage = languageMap[language] || "javascript";

  return (
    <Box sx={theme} w="full">
      <Editor
        language={prismLanguage}
        textareaProps={
          {
            "data-enable-grammarly": false,
            "data-gramm": false,
            "data-gramm_editor": false,
          } as any
        }
        value={children}
        lineNumbers={showLineNumbers}
        readOnly
        wordWrap
      />
    </Box>
  );
}
